import styled from "styled-components";
import { makeStyles } from "@material-ui/core/styles";
import { colors } from "@teamrota/rota-design";
import { STYLE_CONSTS, COLORS } from "~/src/styles/config.style";

export const StyledSentenceCase = styled.p`
  text-transform: capitalize;
`;

export default makeStyles({
  item: {
    marginTop: "15px",
    border: "1px solid transparent"
  },
  uploadButton: {
    backgroundColor: COLORS.MAIN_ORANGE,
    borderRadius: "20px",
    fontSize: STYLE_CONSTS.FONT,
    fontStyle: "normal",
    fontWeight: STYLE_CONSTS.FONT_WEIGHT_MEDIUM,
    textTransform: "none",
    height: "44px",
    textAlign: "center",
    boxShadow: "none",
    "&:hover": {
      backgroundColor: COLORS.MAIN_ORANGE
    }
  },
  uploadButtonDisabled: {
    backgroundColor: COLORS.MAIN_ORANGE,
    opacity: 0.3,
    borderRadius: "20px",
    fontSize: STYLE_CONSTS.FONT,
    fontStyle: "normal",
    fontWeight: STYLE_CONSTS.FONT_WEIGHT_MEDIUM,
    textTransform: "none",
    height: "44px",
    textAlign: "center",
    "&:hover": {
      backgroundColor: COLORS.MAIN_ORANGE
    }
  },
  redBox: {
    height: "8px",
    width: "8px"
  },
  label: {
    fontSize: STYLE_CONSTS.FONT,
    fontStyle: "normal",
    fontWeight: STYLE_CONSTS.FONT_WEIGHT_MEDIUM,
    lineHeight: "17px",
    letterSpacing: "-0.18px"
  },
  formControl: {
    width: "100%",
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      border: `1px solid ${COLORS.MAIN_ORANGE}`
    },
    "& .MuiInputBase-root": {
      "&:hover fieldset": {
        borderColor: COLORS.MAIN_ORANGE
      }
    }
  },
  select: {
    height: "36px",
    borderBotton: "none",
    boxSizing: "border-box",
    borderRadius: "5px",
    fontSize: STYLE_CONSTS.FONT,
    fontStyle: "normal",
    padding: "12px",
    "& .MuiOutlinedInput-input": {
      backgroundColor: "transparent"
    }
  },
  datePickerWrapper: {
    "& input": {
      height: "36px",
      border: `1px solid ${colors.grey}`,
      boxSizing: "border-box",
      borderRadius: "5px",
      fontSize: STYLE_CONSTS.FONT,
      fontWeight: 400
    }
  },
  spinner: {
    color: COLORS.WHITE,
    marginRight: "10px"
  },
  title: {
    fontSize: STYLE_CONSTS.FONT_MEDIUM,
    fontStyle: "normal",
    fontWeight: "normal",
    lineHeight: "18px",
    color: colors.black
  },
  subtitle: {
    fontSize: STYLE_CONSTS.FONT,
    fontStyle: "normal",
    fontWeight: "normal",
    lineHeight: "17px",
    color: COLORS.COOL_GREY
  },
  tooltip: {
    color: colors.fireOrange,
    "& strong": {
      fontWeight: "bold"
    }
  },
  fileNote: {
    fontSize: "11px",
    lineHeight: "13px"
  },
  documentsTable: {
    width: "100%",
    borderCollapse: "collapse",
    textAlign: "center",
    fontSize: STYLE_CONSTS.FONT_SMALL,
    letterSpacing: "-0.18px",
    "& thead": {
      backgroundColor: colors.smokeGrey,
      borderRadius: "10px",
      fontWeight: STYLE_CONSTS.FONT_WEIGHT_MEDIUM,
      color: COLORS.COOL_GREY,
      "& tr": {
        height: "32px",
        "& th:first-child": {
          borderRadius: "10px 0 0 10px"
        },
        "& th:last-child": {
          borderRadius: "0 10px 10px 0"
        }
      }
    },
    "& tbody": {
      "& tr": {
        height: "42px"
      },
      "& a": {
        textDecoration: "none"
      }
    }
  },
  documentIcon: {
    marginLeft: "5px",
    marginRight: "5px",
    color: colors.coolGrey
  }
});

export const StyledValidationError = styled.p`
  color: ${({ theme }) => theme.error.main};
  font-size: 12px;
`;
